import React from "react";
import clsx from 'clsx';

import { makeStyles } from '@material-ui/styles';

import I18n from "../i18n.js";

import ButtonLink from "../links/button_link.js";
import Image from "../components/image.js";

import ProjectStatusEnum from "../../enums/project_status.js";

import ParticipantsInvestmentInfo from "./participants_investment_info.js";

import SmartLink from '../links/smart_link.js';
import Routes from "../../web/routes.js";

const blockStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    margin: "0 -13px 50px",
    ['@media (max-width: 768px)']: {
      marginBottom: "30px"
    }
  },
  investment: {
    flex: "0 0 33.3333%",
    maxWidth: "33.3333%",
    padding: "0 13px",
    marginBottom: "40px",
    textDecoration: "none",
    color: theme.palette.black,
    ['@media (max-width: 992px)']: {
      flex: "0 0 50%",
      maxWidth: "50%"
    },
    ['@media (max-width: 768px)']: {
      flex: "0 0 100%",
      marginBottom: "25px",
      maxWidth: "100%"
    }
  },
  investmentContent: {
    borderRadius: "2px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    padding: "0px 0px 24px",
    overflow: "hidden",
    transition: "box-shadow 0.3s ease-in-out",
    "&:hover": {
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
      transition: "box-shadow 0.3s ease-in-out"
    },
  },
  projectInfo: {

  },
  projectImg: {
    maxWidth: "100%",
    height: "100%",
    width: "100%"
  },
  projectImgWrap: {
    background: theme.palette.grayDisable,
    height: "282px",
    ['@media (max-width: 768px)']: {
      height: "178px",
    }
  }, 
  projectTitle: {
    fontSize: "24px",
    margin: "20px 0",
    padding: "0 20px",
    textTransform: "uppercase",
    ['@media (max-width: 768px)']: {
      fontSize: "18px",
      margin: "23px 0",
    }
  },
  projectStatus: {
    background: theme.palette.greenMain,
    color: "white",
    fontSize: "20px",
    lineHeight: "1",
    padding: "13px 32px",
    position: "absolute",
    top: "19px",
    left: "19px",
    textTransform: "uppercase",
    zIndex: "1",
    ['@media (max-width: 768px)']: {
      fontSize: "11px",
      padding: "8px",
      top: "16px",
      left: "16px",
    }
  },
  investmentInfo: {
    marginTop: "5px"  
  },
  participantInfo: {
    marginBottom: "30px",
    ['@media (max-width: 768px)']: {
      marginBottom: "20px"
    }
  },
  participantInfoInvestmentStatus: {
    ['@media (max-width: 768px)']: {
      padding: "0px 5px"
    },
  },
  participantInfoDate: {
    ['@media (max-width: 768px)']: {
      fontSize: "10px"
    },
  },
  participantInfoAmountRow: {
    ['@media (max-width: 768px)']: {
      fontSize: "13px"
    }
  },
  detailsButton: {
    display: "block",
    fontSize: "20px",
    margin: "5px 20px 0",
    padding: "8px 20px",
    textAlign: "center",
    ['@media (max-width: 768px)']: {
      fontSize: "18px",
      padding: "10px 20px",
    }
  },
}));

const InvestmentsList = props => {
  
  const { className, investments, withProjectInfo = true, onOpenInvestment } = props;
  const classes = blockStyles();

  const titleFormatter = title => {
    if (title.length > 60) {
      return title.slice(0, 60) + "..."
    } 
    else {
      return title
    }
  }

  return(
    <div className = { clsx(classes.root, className) }>
      { 
        investments.map((item) => {
          const { project } = item.participant || {};
          const { mainGalleryImage: { urls } = {} } = project || {};
          
          let src = undefined;
          let srcSet = {};
          if(urls) {
            src = urls.medium;
            srcSet = {
              "2x": urls.medium2x,
              "3x": urls.medium3x
            }
          }
          return <SmartLink key = { item.id }
                            to = { Routes.investment(item) }
                            className = { classes.investment }
                            onClick = { () => {
                              if(onOpenInvestment) {
                                onOpenInvestment();
                              }
                            } } >
            <div className = { classes.investmentContent }>
              {
                withProjectInfo && project && 
                <div className = { classes.projectInfo } >
                  <div className = { classes.projectStatus }>
                    { ProjectStatusEnum.label(project.status) }
                  </div>
                  <div className = { classes.projectImgWrap }>
                    <Image src = { src }
                          alt = { titleFormatter(project.name) }
                          srcSet = { srcSet } 
                          className = { classes.projectImg }/>
                  </div>
                  <div className = { classes.projectTitle }>
                    { titleFormatter(project.name) }
                  </div>
                </div>
              }
              <div className = { classes.investmentInfo } >
                <ParticipantsInvestmentInfo investment = { item } 
                                            className = { classes.participantInfo }
                                            classes = { { 
                                              investmentStatus: classes.participantInfoInvestmentStatus,
                                              date: classes.participantInfoDate,
                                              amountRow: classes.participantInfoAmountRow
                                            } } /> 
                <ButtonLink className = { classes.detailsButton }
                            to = { Routes.investment(item) }
                            component = { "span" } >
                  { I18n.t("action.go_to_details") }
                </ButtonLink>
              </div>  
            </div>
          </SmartLink>
        }) 
      }
    </div>
  )
}

export default InvestmentsList;
